module.exports = __webpack_public_path__ + "static/media/tumblr.94e61c1d.svg";